// extracted by mini-css-extract-plugin
export default {"DisclaimerWidget":"Styles_DisclaimerWidget__UuaXa"};